export enum GodziDropAnimation {
  open = 'OP_S',
  silverLevelIntro = 'egg_LV01_S',
  goldLevelIntro = 'egg_LV02_S',
  vipLevelIntro = 'egg_LV03_S',
  ratioPrize = 'prize_S_multiplier',
  freeGamePrize = 'prize_S_freeGame',
  freeSpinPrize = 'prize_S_freeSpin',
  totalWin = 'totalWin_S',
  betterLuckVertical = 'betterLuck_S',
}
